export default __webpack_public_path__ + "static/media/Flag of Kiribati.ab38a3fd.gif";